function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_90621:21139)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.11685 1.61779C6.99553 1.58046 6.86369 1.60293 6.76158 1.67834C6.65947 1.75376 6.59922 1.87316 6.59922 2.0001V9.92393C6.13206 9.47562 5.49782 9.2001 4.79922 9.2001C3.36328 9.2001 2.19922 10.3642 2.19922 11.8001C2.19922 13.236 3.36328 14.4001 4.79922 14.4001C6.23516 14.4001 7.39922 13.236 7.39922 11.8001C7.39922 11.7518 7.3979 11.7039 7.39531 11.6563C7.39789 11.6379 7.39922 11.6192 7.39922 11.6001V5.74168L12.0816 7.18241C12.2029 7.21974 12.3348 7.19727 12.4369 7.12186C12.539 7.04644 12.5992 6.92704 12.5992 6.8001V4.78182C12.5992 3.90381 12.0266 3.12847 11.1874 2.87026L7.11685 1.61779Z",
  fill: "black",
  fillOpacity: 0.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 15C8 11.6863 10.6863 9 14 9C17.3137 9 20 11.6863 20 15C20 18.3137 17.3137 21 14 21C10.6863 21 8 18.3137 8 15ZM16.5 15C16.5 14.8199 16.4032 14.6538 16.2465 14.565L13.6198 13.0765C13.1198 12.7932 12.5 13.1544 12.5 13.7291V16.271C12.5 16.8457 13.1198 17.2068 13.6198 16.9235L16.2465 15.435C16.4032 15.3462 16.5 15.1801 16.5 15Z",
  fill: "black",
  fillOpacity: 0.6
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_90621:21139"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

function SvgMusicPlayCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicPlayCircle);
export default __webpack_public_path__ + "static/media/music-play-circle.4df7fb33.svg";
export { ForwardRef as ReactComponent };